import { jsx as i } from "react/jsx-runtime";
import n from "react";
import s from "../../TabListLayout/index.js";
import m from "../../../contexts/tab.js";
function p(t) {
  const o = n.useContext(m), {
    colorVariant: r,
    styleVariant: a,
    disabled: e
  } = o;
  return /* @__PURE__ */ i(
    s,
    {
      ...t,
      styleVariant: a,
      colorVariant: r,
      disabled: e
    }
  );
}
export {
  p as default
};
